import React, { useState, useEffect, useMemo } from "react";
import { Table, Form, OverlayTrigger, Tooltip } from "react-bootstrap";
import Pagination from "../../../../../components/Pagination";
import SearchBar from "../../../../../components/SearchBar";
import PrintEmailFilter from "./PrintEmailFilter";
import { FaSpinner } from "react-icons/fa";

const PrintEmailComponent = ({
  data,
  dataSets,
  isApiStatus,
  columnHeadersMap,
  selectedResource,
  selectAllChecked,
  checkBoxRequiredMap,
  searchTerm,
  handleReset,
  setSearchTerm,
  isFilterRequired,
  formDatas,
  handleGetData,
  handleChange,
  filterFormData,
  handleCheckboxChange,
  formattedKeys,
  totals,
  handleSubmitButton,
  handleSelectAllChange,
  isActionRequired,
  showIcon1,
  showIcon2,
  showIcon3,
  showIcon4,
  showIcon5,
  handleIcon1,
  handleIcon2,
  handleIcon3,
  handleIcon4,
  handleIcon5,
  icons,
}) => {
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [activeTab, setActiveTab] = useState(Object.keys(dataSets)[0]);
  const datasetKeys = Object.keys(dataSets);
  const [visibleColumns, setVisibleColumns] = useState({});
  const [sortConfig, setSortConfig] = useState({
    key: null,
    direction: "ascending",
  });

  useEffect(() => {
    setCurrentPage(1);
  }, [searchTerm]);

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const sortedData = useMemo(() => {
    if (!Array.isArray(dataSets?.["Pay Slab Line"]) || !sortConfig)
      return dataSets?.["Pay Slab Line"] || [];

    const { key, direction } = sortConfig;

    return [...dataSets?.["Pay Slab Line"]].sort((a, b) => {
      const valA = a[key] ? String(a[key]) : "";
      const valB = b[key] ? String(b[key]) : "";

      const partsA = valA.match(/(\D+|\d+)/g) || [];
      const partsB = valB.match(/(\D+|\d+)/g) || [];

      for (let i = 0; i < Math.max(partsA.length, partsB.length); i++) {
        const partA = partsA[i] || "";
        const partB = partsB[i] || "";

        const isNumericA = !isNaN(partA);
        const isNumericB = !isNaN(partB);

        if (isNumericA && isNumericB) {
          const numA = Number(partA);
          const numB = Number(partB);
          if (numA !== numB)
            return direction === "ascending" ? numA - numB : numB - numA;
        } else if (isNumericA || isNumericB) {
          return isNumericA ? -1 : 1;
        } else {
          const comparison = partA.localeCompare(partB);
          if (comparison !== 0)
            return direction === "ascending" ? comparison : -comparison;
        }
      }

      return 0;
    });
  }, [dataSets?.["Pay Slab Line"], sortConfig]);

  const filteredData = sortedData.filter((item) =>
    Object.values(item).some((value) =>
      String(value).toLowerCase().includes(searchTerm.toLowerCase())
    )
  );
  const startIndex = (currentPage - 1) * itemsPerPage;
  const endIndex = Math.min(startIndex + itemsPerPage, filteredData.length);
  const currentData = filteredData.slice(startIndex, endIndex);

  const recordsPerPageOption = [
    { value: 10, label: "10" },
    { value: 25, label: "25" },
    { value: 50, label: "50" },
    { value: 100, label: "100" },
    { value: filteredData.length, label: "All" },
  ];

  const [selectedRecordsPerPage, setSelectedRecordsPerPage] = useState(10);

  const totalPages = Math.ceil(filteredData.length / selectedRecordsPerPage);

  const currentPageData = filteredData.slice(
    (currentPage - 1) * selectedRecordsPerPage,
    currentPage * selectedRecordsPerPage
  );

  const handleRecordsPerPage = (e) => {
    const newRecordsPerPage = Number(e.target.value);
    const currentStartIndex = (currentPage - 1) * selectedRecordsPerPage;
    const newPage = Math.floor(currentStartIndex / newRecordsPerPage) + 1;
    setSelectedRecordsPerPage(newRecordsPerPage);
    setCurrentPage(newPage); // Adjust to the new page based on the same starting record index
    setItemsPerPage(newRecordsPerPage);
  };

  useEffect(() => {
    const dropdownElements = document.querySelectorAll(".dropdown-toggle");
    dropdownElements.forEach((dropdown) => {
      new window.bootstrap.Dropdown(dropdown);
    });
  }, []);

  return (
    <div className="container-fluid ">
      <div className="row d-flex justify-content-between align-items-center">
        {/* Left Section: Search Bar & Filters */}
        <div className="col-md-6 d-flex align-items-center">
          <div className="me-2 mt-3">
            <SearchBar searchTerm={searchTerm} setSearchTerm={setSearchTerm} />
          </div>
          {isFilterRequired && (
            <div className="dropdown">
              <OverlayTrigger
                placement="right"
                overlay={<Tooltip id="tooltip-bottom">Filters</Tooltip>}
              >
                <button
                  className="dropdown-toggle"
                  type="button"
                  id="excel-btn"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                >
                  <i className="bi bi-funnel-fill"></i>
                </button>
              </OverlayTrigger>
              <div>
                <PrintEmailFilter
                  formData={formDatas || []}
                  handleChange={handleChange}
                  handleReset={handleReset}
                  handleGetData={handleGetData}
                  filterFormData={filterFormData}
                />
              </div>
            </div>
          )}
        </div>
        {/* <div className="col-md-6 d-flex justify-content-end align-items-center">

          <div className="d-flex align-items-center mt-3">

            <button className="custom-btn" onClick={handleSubmitButton}>Get All Mail</button>
          </div>
        </div> */}
      </div>
      <div className="m-0">
        <div className=" m-0 p-0">
          <ul className="nav nav-tabs">
            {datasetKeys?.map((key, index) => (
              <li className="nav-item" key={index}>
                <button
                  className={`nav-link ${activeTab === key ? "active" : ""}`}
                  onClick={() => setActiveTab(key)}
                >
                  {key} {/* Dynamically set tab name */}
                </button>
              </li>
            ))}
          </ul>
          {/* Dynamic Tabs Content */}
          <div className="tab-content mt-3">
            {datasetKeys.map((key, index) => {
              const currentData = dataSets[key];
              const columnHeaders = columnHeadersMap[key] || []; // Get custom columns for the current tab
              return (
                <div
                  key={index}
                  className={`table-responsive tab-pane fade ${activeTab === key ? "show active" : ""
                    }`}
                >
                  <Table striped bordered hover rounded>
                    <thead id="thcolor" className="text-center">
                      <tr>
                        {columnHeaders.map(
                          (col, i) =>
                            visibleColumns[col.key] !== false && (
                              <th
                                key={i}
                                style={{
                                  width: col.width || "150px", // Default width 150px or use specified width
                                  minWidth: "100px",
                                  maxWidth: "300px",
                                  overflow: "hidden",
                                  textOverflow: "ellipsis",
                                  whiteSpace: "nowrap",
                                }}
                              >
                                {col.label}
                              </th>
                            )
                        )}
                        {isActionRequired && (
                          <th style={{ width: "120px" }}>Action</th>
                        )}
                      </tr>
                    </thead>
                    <tbody>
                      {isApiStatus === 200 && currentPageData.length > 0 ? (
                        <>
                          {currentPageData.map((row, i) => (
                            <tr key={i}>
                              {columnHeaders.map(
                                (col, j) =>
                                  visibleColumns[col.key] !== false && (
                                    <td
                                     
                                      key={j}
 className={col.key !== "Employee"&&col.key !== "Email" ? "text-end" : "text-start"}                                      style={{
                                        maxWidth: "300px",
                                        overflow: "hidden",
                                        textOverflow: "ellipsis",
                                        whiteSpace: "nowrap",
                                      }}
                                      title={String(row[col.key])} // Show full text on hover
                                    >
                                      {row[col.key]}
                                    </td>
                                  )
                              )}
                              {isActionRequired && (
                                <td>
                                  <div className="d-flex justify-content-center text-center">
                                    {showIcon1 && (
                                      <OverlayTrigger
                                        placement="bottom"
                                        overlay={
                                          <Tooltip id="tooltip-bottom">
                                            {icons.Icon1Text || "Edit"}
                                          </Tooltip>
                                        }
                                      >
                                        <div
                                          className={`me-2 ${row[icons.Icon1Flag] === 0 ||
                                              row[icons.Icon1Flag] === false
                                              ? "disabled-icon"
                                              : ""
                                            }`}
                                          onClick={() => {
                                            if (
                                              row[icons.Icon1Flag] !== 0 &&
                                              row[icons.Icon1Flag] !== false
                                            ) {
                                              handleIcon1(row);
                                            }
                                          }}
                                        >
                                          {icons.Icon1}
                                        </div>
                                      </OverlayTrigger>
                                    )}
                                    {showIcon2 && (
                                      <OverlayTrigger
                                        placement="bottom"
                                        overlay={
                                          <Tooltip id="tooltip-bottom">
                                            {icons.Icon2Text || "Edit"}
                                          </Tooltip>
                                        }
                                      >
                                        <div
                                          className={`me-2 ${row[icons.Icon2Flag] === 0 ||
                                              row[icons.Icon2Flag] === false
                                              ? "disabled-icon"
                                              : ""
                                            }`}
                                          onClick={() => {
                                            if (
                                              row[icons.Icon2Flag] !== 0 &&
                                              row[icons.Icon2Flag] !== false
                                            ) {
                                              handleIcon2(row);
                                            }
                                          }}
                                        >
                                          {icons.Icon2}
                                        </div>
                                      </OverlayTrigger>
                                    )}
                                    {showIcon3 && (
                                      <OverlayTrigger
                                        placement="bottom"
                                        overlay={
                                          <Tooltip id="tooltip-bottom">
                                            {icons.Icon3Text}
                                          </Tooltip>
                                        }
                                      >
                                        <div
                                          className={`me-2 ${row[icons.Icon3Flag] === 0
                                              ? "disabled-icon"
                                              : ""
                                            }`}
                                          onClick={() => {
                                            if (row[icons.Icon3Flag] !== 0)
                                              handleIcon3(row);
                                          }}
                                        >
                                          {icons.Icon3}
                                        </div>
                                      </OverlayTrigger>
                                    )}
                                    {showIcon4 && (
                                      <OverlayTrigger
                                        placement="bottom"
                                        overlay={
                                          <Tooltip id="tooltip-bottom">
                                            {icons.Icon4Text || "Add"}
                                          </Tooltip>
                                        }
                                      >
                                        <div
                                          className={`me-2 ${row[icons.Icon4Flag] === 0
                                              ? "disabled-icon"
                                              : ""
                                            }`}
                                          onClick={() => {
                                            if (row[icons.Icon4Flag] !== 0)
                                              handleIcon4(row);
                                          }}
                                        >
                                          {icons.Icon4}
                                        </div>
                                      </OverlayTrigger>
                                    )}
                                    {showIcon5 && (
                                      <OverlayTrigger
                                        placement="bottom"
                                        overlay={
                                          <Tooltip id="tooltip-bottom">
                                            {icons.Icon5Text || "Add"}
                                          </Tooltip>
                                        }
                                      >
                                        <div
                                          className={`me-2 ${row[icons.Icon5Flag] === 0
                                              ? "disabled-icon"
                                              : ""
                                            }`}
                                          onClick={() => {
                                            if (row[icons.Icon5Flag] !== 0)
                                              handleIcon5(row);
                                          }}
                                        >
                                          {icons.Icon5}
                                        </div>
                                      </OverlayTrigger>
                                    )}
                                  </div>
                                </td>
                              )}
                            </tr>
                          ))}
                          {filteredData.length > 0 && (
          <tr style={{ fontWeight: "bold", backgroundColor: "#f0f0f0" }}>
            <td>{`Count: ${filteredData.length}`}</td>
            
            {columnHeaders.slice(1).map((col) => {  // Skip first column (Count)
              const excludedKeys = ["Employee", "Email"];
              
              return (
                <td   className={col.key !== "Employee"&&col.key !== "Email" ? "text-end" : "text-start"} key={col.key} >
                  {!excludedKeys.includes(col.key)
                    ? isNaN(totals[col.key])
                      ? ""
                      : Number(totals[col.key]).toFixed(2)
                    : ""}
                </td>
              );
            })}
            
            {/* Empty cell for Action column if present */}
            {isActionRequired && <td></td>}
          </tr>
        )}
                        </>
                      ) : isApiStatus === 200 &&
                        currentPageData.length === 0 ? (
                        <tr>
                          <td
                            colSpan={
                              columnHeaders.length + (isActionRequired ? 1 : 0)
                            }
                            className="text-center"
                          >
                            No Data Found
                          </td>
                        </tr>
                      ) : isApiStatus === undefined &&
                        currentData.length === 0 ? (
                        <tr>
                          <td
                            colSpan={
                              columnHeaders.length + (isActionRequired ? 1 : 0)
                            }
                            className="text-center"
                          >
                            <p>
                              <FaSpinner className="spinner" />
                              <br />
                              Loading
                            </p>
                          </td>
                        </tr>
                      ) : isApiStatus === undefined  ? (
                        <tr>
                          <td
                            colSpan={
                              columnHeaders.length + (isActionRequired ? 1 : 0)
                            }
                            className="text-center"
                          >
                            <p>
                              <FaSpinner className="spinner" />
                              <br />
                              Loading
                            </p>
                          </td>
                        </tr>
                      ) : currentPageData.length === 0 ? (
                        <tr>
                          <td
                            colSpan={
                              columnHeaders.length + (isActionRequired ? 1 : 0)
                            }
                            className="text-center"
                          >
                            No Data Found
                          </td>
                        </tr>
                      ) : null}
                    </tbody>
                  </Table>
                </div>
              );
            })}
          </div>
        </div>
        {/* {filteredData.length > itemsPerPage && ( */}
        <div className="d-flex justify-content-between mb-3">
          <div>
            <span className="d-flex">
              Showing {(currentPage - 1) * selectedRecordsPerPage + 1} -{" "}
              {Math.min(
                currentPage * selectedRecordsPerPage,
                filteredData.length
              )}{" "}
              of {filteredData.length}
              <select
                value={selectedRecordsPerPage}
                onChange={handleRecordsPerPage}
                className="mx-2 form-select-sm"
              >
                {recordsPerPageOption.map((opt) => (
                  <option key={opt.value} value={opt.value}>
                    {opt.label}
                  </option>
                ))}
              </select>
            </span>
          </div>
          <div>
            <Pagination
              itemsPerPage={selectedRecordsPerPage}
              totalItems={filteredData.length}
              currentPage={currentPage}
              onPageChange={handlePageChange}
            />
          </div>
        </div>
        {/* )} */}
      </div>
    </div>
  );
};
export default PrintEmailComponent;
